import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG_BY_COMMUNITY } from "./apiRoutes";

const mutateUpdateDocumentTypeStatus = async ({
  communityId,
  documentTypeId,
  active,
}: {
  communityId: string;
  documentTypeId: string;
  active: boolean;
}) => {
  return await axiosAuth.patch(
    `${DOCUMENT_TYPE_CONFIG_BY_COMMUNITY(communityId)}/${documentTypeId}/status`,
    null,
    {
      params: {
        active,
      },
    }
  );
};

const useUpdateDocumentTypeStatusMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      documentTypeId: string;
      active: boolean;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateDocumentTypeStatus,
    ...queryParams,
  });

export default useUpdateDocumentTypeStatusMutation;
